import saudiFlag from "../assets/svg-flags/Saudi-Flag.svg";
import uaeFlag from "../assets/svg-flags/UAE.svg";
import qatarFlag from "../assets/svg-flags/Qatar.svg";
import kuwaitFlag from "../assets/svg-flags/Kuwait.svg";
import omaniFlag from "../assets/svg-flags/omani.svg";
import englishFlag from "../assets/svg-flags/English.svg";

const countries = [
    { name: "saudi", flag: saudiFlag },
    { name: "omani", flag: omaniFlag },
    { name: "uae", flag: uaeFlag },
    { name: "kuwaiti", flag: kuwaitFlag },
    { name: "qatari", flag: qatarFlag }
];

const stores = [
    {
        name: "sa",
        flag: saudiFlag,
        ar: { store: "المتجر السعودى", currency: "ريال سعودى" },
        en: { store: "Saudi Store", currency: "Saudi Riyal" }
    },
    {
        name: "om",
        flag: omaniFlag,
        ar: { store: "المتجر العمانى", currency: "ريال عمانى" },
        en: { store: "Omani Store", currency: "Omani Riyal" }
    },
    {
        name: "ae",
        flag: uaeFlag,
        ar: { store: "المتجر الامراتى", currency: "درهم إماراتى" },
        en: { store: "Emarati Store", currency: "Emarati Dirham" }
    },
    {
        name: "kw",
        flag: kuwaitFlag,
        ar: { store: "المتجر الكويتى", currency: "دينار كويتى" },
        en: { store: "Kuwiti Store", currency: "Kuwiti Dinar" }
    },
    {
        name: "qa",
        flag: qatarFlag,
        ar: { store: "المتجر القطرى", currency: "ريال قطرى" },
        en: { store: "Qatari Store", currency: "Qatari Riyal" }
    },
    {
        name: "en",
        flag: englishFlag,
        ar: { store: "المتجر الانجليزى", currency: "دولار" },
        en: { store: "English Store", currency: "Dollar" }
    }
];

export { saudiFlag, englishFlag, countries, stores, uaeFlag, omaniFlag, qatarFlag, kuwaitFlag };
